function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import { debounce } from "debounce";
// navigation menu configurations
import config from '../configs';
import FormMetaDatasource from '@/components/tableau/FormMetaDatasource';
import FormAccessRequestDatasource from '@/components/tableau/FormAccessRequestDatasource';
import FormMetaDashboard from '@/components/tableau/FormMetaDashboard';
import FormAccessRequestWorkbook from '@/components/tableau/FormAccessRequestWorkbook';
import FormSelectTableauUser from '@/components/tableau/FormSelectTableauUser';
import FormMetadataTableComponent from '@/apps/data-platform/components/FormMetadataTableComponent.vue';
import FormAccessRequestTableComponent from '@/apps/data-platform/components/FormAccessRequestTableComponent.vue';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import TableauUserAccessService from '@/apps/data-platform/services/visualization/tableauRol';
import FormMetaDataset from '@/modules/tasks/powerbi/components/FormMetaDataset';
import FormAccessRequestDataset from '@/modules/tasks/powerbi/components/FormAccessRequestDataset';
import FormSelectBiUser from '@/modules/tasks/powerbi/components/FormSelectBIUser.vue';
import FormMetaReportDatastudio from '@/modules/tasks/datastudio/components/FormMetaReportDatastudio';
import FormAccessRequestReportGds from '@/modules/tasks/datastudio/components/FormAccessRequestReportGDS';
import FormMetaReport from '@/modules/tasks/powerbi/components/report/FormMetaReport';
import FormAccessRequestReport from '@/modules/tasks/powerbi/components/report/FormAccessRequestReport';
import BiUserAccessService from '@/apps/data-platform/services/visualization/bi_user_access_service';
import DialogsComponent from '@/components/DialogsComponent.vue';
import MainMenu from '../components/navigation/MainMenu';
import ToolbarUser from '../components/toolbar/ToolbarUser';
import ToolbarApps from '../components/toolbar/ToolbarApps';
import ToolbarLanguage from '../components/toolbar/ToolbarLanguage';
import ToolbarCurrency from '../components/toolbar/ToolbarCurrency';
import ToolbarNotifications from '../components/toolbar/ToolbarNotifications';
import ToolbarAttributes from '@/components/toolbar/ToolbarAttributes';
import ToolbarSettings from '@/components/toolbar/ToolbarSettings';
import { PATTERNS_VALIDATION, ALL_TABLES_OPTION, TYPSE_SENSE_TYPE_OBJECTS, ACCESS_TYPE_FLOW, TYPE_CHANGE_METADA, GA_EVENTS } from '@/js/constants';
import firebase from 'firebase';
import 'firebase/firebase-messaging';
import userSecurotyService from '@/apps/data-platform/services/security/user_security_service';
import search_engine_service from '@/apps/data-platform/services/search_engine_service';
import resources_service from '@/apps/data-platform/services/tables_views/resources_service';
import tasks from '@/js/tasks';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import utils from '@/js/utils';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import assignments_service from '@/apps/data-platform/services/tables_views/assignments_service';
import FloatingButtonComponent from '@/components/FloatingButtonComponent';
import userSettingsService from '@/apps/data-platform/services/security/user_settings_service';
export default {
  components: {
    MainMenu: MainMenu,
    ToolbarUser: ToolbarUser,
    ToolbarApps: ToolbarApps,
    ToolbarLanguage: ToolbarLanguage,
    ToolbarCurrency: ToolbarCurrency,
    ToolbarNotifications: ToolbarNotifications,
    ToolbarAttributes: ToolbarAttributes,
    ToolbarSettings: ToolbarSettings,
    DialogsComponent: DialogsComponent,
    FormMetadataTableComponent: FormMetadataTableComponent,
    FormAccessRequestTableComponent: FormAccessRequestTableComponent,
    FormMetaDatasource: FormMetaDatasource,
    FormAccessRequestDatasource: FormAccessRequestDatasource,
    FormSelectTableauUser: FormSelectTableauUser,
    FormMetaDashboard: FormMetaDashboard,
    FormAccessRequestWorkbook: FormAccessRequestWorkbook,
    FormMetaDataset: FormMetaDataset,
    FormAccessRequestDataset: FormAccessRequestDataset,
    FormSelectBiUser: FormSelectBiUser,
    FormMetaReport: FormMetaReport,
    FormAccessRequestReport: FormAccessRequestReport,
    FormMetaReportDatastudio: FormMetaReportDatastudio,
    FormAccessRequestReportGds: FormAccessRequestReportGds,
    FloatingButtonComponent: FloatingButtonComponent
  },
  data: function data() {
    return {
      mini: true,
      drawer: false,
      showSearch: false,
      menuBuscador: false,
      semanticSearch: false,
      q: '',
      SEARCH_PATTERN: PATTERNS_VALIDATION.MAIN_SEARCH,
      buttons: [],
      list_domains: ['aaa', 'bbbb'],
      pick_domain: 'Domains',
      navigation: config.navigation,
      pill_selected: {},
      mostrarSugerencia: false,
      estaBuscando: false,
      filtro: {
        domain: null,
        object: [{
          value: TYPSE_SENSE_TYPE_OBJECTS.TABLE + ',' + TYPSE_SENSE_TYPE_OBJECTS.VIEW,
          text: this.translate('menu.toolbar.table_views')
        }],
        object_comma: null,
        q: null,
        per_page: 5,
        page: 1
      },
      encontrado: {
        'found': 0,
        'page': 1,
        'per_page': 10,
        'q': '',
        'search_time_ms': 0,
        'busqueda': []
      },
      existeBusqueda: false,
      TYPSE_SENSE_TYPE_OBJECTS: TYPSE_SENSE_TYPE_OBJECTS,
      currentImage: {},
      currentViewPage: 1,
      currentView: {},
      objToRequest: {},
      lazyLoadParamsForViewer: null,
      objDatasource: {},
      objDashboard: {},
      tableauType: '',
      key_meta: 1,
      key_view: 1,
      key_request: 1,
      pushWeb: process.env.VUE_APP_FCM_API_KEY,
      env: process.env.VUE_APP_ENV,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      userTableau: null,
      userTableauOptions: [],
      isChangeRequest: '',
      MODAL_DATASOURCE_METADATA_VIEW: 'modalDatasourceMetadataView',
      MODAL_DATASOURCE_METADATA_ACCESS: 'modalDatasourceMetadataAccess',
      MODAL_WORKBOOK_METADATA_VIEW: 'modalWorkbookMetadataView',
      MODAL_WORKBOOK_METADATA_ACCESS: 'modalWorkbookMetadataAccess',
      MODAL_SELECT_USER_TABLEAU: 'modalSelectUserDatasource',
      MODAL_PREVIEW_IMAGE: 'modalPreviewImage',
      MODAL_DATASET_METADATA_VIEW: 'modalDatasetMetadataView',
      MODAL_DATASET_METADATA_ACCESS: 'modalDatasetMetadataAccess',
      MODAL_REPORT_METADATA_VIEW: 'modalReportMetadataView',
      MODAL_REPORT_METADATA_ACCESS: 'modalReportMetadataAccess',
      MODAL_REPORT_METADATA_VIEW_GDS: 'modalReportMetadataViewGDS',
      MODAL_REPORT_METADATA_ACCESS_GDS: 'modalReportMetadataAccessGDS',
      MODAL_SELECT_USER_BI: 'modalSelectUserBIDataset',
      MODAL_NAME: 'ListObjectsSearch',
      MODAL_NAME_METADATA_VIEW: 'ListObjectsSearchMetadataView',
      MODAL_NAME_METADATA: 'ListObjectsSearchMetadataChange',
      MODAL_NAME_LINEAGE: 'ListObjectsSearchLineage',
      userBI: null,
      emailBI: null,
      userBIOptions: [],
      objDataset: {},
      objReport: {},
      biType: '',
      objReportGds: {},
      isPageDataPlatform: true,
      isPageSearch: true,
      isPageHome: false,
      peticionesBuscador: 0,
      keyNotifications: 1,
      isSynapse: false,
      searchs: [],
      source: "bigquery",
      is_new_version: false,
      new_version: ''
    };
  },
  watch: {
    $route: function $route(to, from) {
      // //console.log("change route")
      this.checkPageHome();
      this.checkPageDataPlatform();
      this.checkPageSearch();
    }
  },
  created: function created() {
    var _this = this;
    console.log("default layout app created");
    userSettingsService.get_last_searchs({
      "email": this.userInfo.email
    }).then(function (response) {
      if (response.data) _this.searchs = response.data;
      //console.log("searchs: ", this.searchs)
    });
    //console.log('Created Default Layout')
    this.q = this.$router.currentRoute.params.q;
    this.pick_domain = this.$router.currentRoute.params.domain ? this.$router.currentRoute.params.domain : window.userInfo.domain;
    this.subscribeMessaging();
    this.startListeners();
    ////console.log(this.$fire)
    //console.log('--env--')
    //console.log(this.env)
    this.checkPageHome();
    this.checkPageDataPlatform();
    this.checkPageSearch();
    this.verifyVersion();
    //var x = event.clientX, y = event.clientY;
    /*
    var scrollY = window.scrollY;
     setTimeout(function () {var activedMenu = document.querySelector(".v-tooltip__content.menuable__content__active")
     document.querySelector(".v-tooltip__content.menuable__content__active").style.top = (parseInt(activedMenu.style.top) - scrollY)+"px";
     }, 250);
    */
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['product', 'isContentBoxed', 'menuTheme', 'toolbarTheme', 'isToolbarDetached', 'showLoading', 'showMessage', 'toastMessage'])), mapState('data-platform', ['isTableauActive', 'mainQueryBy', 'isPowerBIActive', 'isDataStudioActive', 'messagingToken', 'newNotifications', 'orgs', 'filtrosbusqueda', 'isSynapseAccessFunction', 'isBigqueryAccessFunction', 'orgs', 'deploy_version'])), mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    isReadonly: function isReadonly() {
      if (this.isChangeRequest === this.ACCESS_TYPE_FLOW.ACCESS) {
        return true;
      } else if (this.isChangeRequest === this.ACCESS_TYPE_FLOW.CHANGE_METADATA) {
        return false;
      }
      return true;
    },
    processd_list_domains: function processd_list_domains() {
      var list_domains = [];
      //list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : []
      //list_domains.unshift(window.userInfo.domain)
      this.orgs.forEach(function (x) {
        list_domains.push({
          text: x.alias,
          value: x.domain
        });
      });
      list_domains.push({
        text: ALL_TABLES_OPTION,
        value: ALL_TABLES_OPTION
      });
      return list_domains;
    },
    object_types: function object_types() {
      return [{
        value: TYPSE_SENSE_TYPE_OBJECTS.TABLE + ',' + TYPSE_SENSE_TYPE_OBJECTS.VIEW,
        text: this.translate('menu.toolbar.table_views')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.TERM,
        text: this.translate('menu.toolbar.business_terms')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE,
        text: this.translate('menu.toolbar.tbl_datasources')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD,
        text: this.translate('menu.toolbar.tbl_dashboards')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET,
        text: this.translate('menu.toolbar.pbi_datasets')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT,
        text: this.translate('menu.toolbar.pbi_reports')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT,
        text: this.translate('menu.toolbar.gds_reports')
      }];
    },
    getWithContainerBuscador: function getWithContainerBuscador() {
      var _this2 = this;
      return function () {
        return _this2.$refs['ctn_buscador'] ? _this2.$refs['ctn_buscador'].clientWidth : 700;
      };
    },
    shouldShowFloatingButton: function shouldShowFloatingButton() {
      var _this3 = this;
      var excludedPatterns = [/^\/AssessmentReport$/, /^\/LogPowerBI$/, /^\/MonitoringReportsView$/, /^\/attributes\/managment\/metrics$/, /^\/customer_insights\/looker_viewer\/dashboard\/.+/, /^\/customer_insights\/somos1\/dashboard\/.+/];
      console.log(this.$route.path, 'this.$route.path');
      return !excludedPatterns.some(function (pattern) {
        return pattern.test(_this3.$route.path);
      });
    },
    customNavigation: function customNavigation() {
      var menu = JSON.parse(JSON.stringify(this.navigation.menu));
      var attrsMenu = menu.find(function (item) {
        return item.key === 'menu.attributes';
      });
      if (attrsMenu && attrsMenu.items && Array.isArray(attrsMenu.items)) {
        var useCases = attrsMenu.items.find(function (i) {
          return i.key === 'menu.attrs.use_cases';
        });
        if (useCases && useCases.subItems && Array.isArray(useCases.subItems)) {
          var sandboxItem = useCases.subItems.find(function (i) {
            return i.key === 'menu.attrs.create_sandbox';
          });
          if (sandboxItem && this.companyCode === '000') {
            sandboxItem.link = '/attributes/sandbox/request';
            sandboxItem.href = {
              name: 'athena_sandbox'
            };
          }
        }
      }
      return menu;
    }
  }),
  mounted: function mounted() {
    //this.changeButtonState()
    this.$store.dispatch('data-platform/getBusinessDomainQuery');
    this.setIsDomainItc(window.userInfo.domain === 'intercorp.com.pe');
    this.getResources();
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('blur', this.handleWindowBlur);
    window.addEventListener('focus', this.handleWindowFocus);
  },
  unmounted: function unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('blur', this.handleWindowBlur);
    window.removeEventListener('focus', this.handleWindowFocus);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('data-platform', ['setMessagingToken', 'setIsDomainItc'])), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    onLoadNewVersion: function () {
      var _onLoadNewVersion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return caches.keys().then(function (cacheNames) {
                return Promise.all(cacheNames.map(function (cacheName) {
                  return caches.delete(cacheName);
                }));
              });
            case 1:
              window.location.replace(window.location.href.split('?')[0] + '?nocache=' + new Date().getTime());
              window.location.reload(true);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      function onLoadNewVersion() {
        return _onLoadNewVersion.apply(this, arguments);
      }
      return onLoadNewVersion;
    }(),
    handleVisibilityChange: function handleVisibilityChange() {
      if (document.hidden) {
        // La página está oculta (el usuario cambió de pestaña)
        this.isPageVisible = false;
        //console.log('La página está oculta');
      } else {
        // La página está visible (el usuario volvió a esta pestaña)
        this.isPageVisible = true;
        //console.log('La página está visible nuevamente');
        this.verifyVersion();
      }
    },
    verifyVersion: function verifyVersion() {
      var _this4 = this;
      //console.log(location.host)
      fetch(location.origin + '/build_version.json?cache=' + new Date().getTime(), {
        method: 'GET' // or 'POST', 'PUT', 'DELETE', etc.
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      }).then(function (response) {
        //console.log(response)
        //console.log('Version cargada.');
        if (_this4.deploy_version == '2.0.0') {
          var version = response.v;
          _this4.$store.dispatch('data-platform/setDeployVersion', version);
        } else {
          if (response.v !== _this4.deploy_version) {
            console.log("hay una nueva version");
            //this.onLoadNewVersion()
            _this4.is_new_version = true;
            _this4.new_version = 'v.' + response.v;
          } else {}
        }
      }).catch(function (error) {
        //console.log('No se pudo cargar la version.');
      });
    },
    handleWindowBlur: function handleWindowBlur() {
      // La ventana ha perdido el foco
      this.isWindowFocused = false;
      //console.log('La ventana ha perdido el foco (cambio de ventana o minimización)');
    },
    handleWindowFocus: function handleWindowFocus() {
      // La ventana ha ganado el foco nuevamente
      this.isWindowFocused = true;
      //console.log('La ventana ha ganado el foco nuevamente');
    },
    handleScroll: function handleScroll(event) {
      //var x = event.clientX, y = event.clientY
      //console.log(event, x, y)
    },
    new_receive: function new_receive() {
      this.keyNotifications = this.keyNotifications + 1;
      this.$forceUpdate();
    },
    searchAgain: function searchAgain(q, e) {
      e.preventDefault();
      console.log("search again: " + q);
      this.q = q;
      this.sendToSearch();
    },
    removeSearch: function removeSearch(q) {
      var _this5 = this;
      userSettingsService.delete_search({
        "email": this.userInfo.email,
        "q": q
      }).then(function (response) {
        if (response.data) {
          _this5.searchs = response.data;
          //console.log("searchs: ", this.searchs)
          userSettingsService.get_last_searchs({
            "email": _this5.userInfo.email
          }).then(function (response) {
            if (response.data) _this5.searchs = response.data;
            //console.log("searchs: ", this.searchs)
          });
        }
      });
    },
    getRamdonKey: function getRamdonKey() {
      return Math.round(Math.random() * 1000);
    },
    getClientHeight: function getClientHeight() {
      return window.innerHeight - 200 - (this.$refs['filters_modal'] ? this.$refs['filters_modal'].clientHeight : 50);
    },
    onOpenBuscador: function onOpenBuscador(event) {
      if (event) {
        this.sugerir();
      }
    },
    similarityPercent: function similarityPercent(distance) {
      return Math.round((1 - distance) * 100);
    },
    similarityColor: function similarityColor(distance) {
      var pct = (1 - distance) * 100;
      return pct >= 85 ? 'success' : pct >= 75 ? 'warning' : 'error';
    },
    formatNumber: function formatNumber(number) {
      return number ? new Intl.NumberFormat('es-MX').format(number) : 0;
    },
    formatBytes: function formatBytes(bytes) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      if (!+bytes) return '0 Bytes';
      var k = 1024;
      var dm = decimals < 0 ? 0 : decimals;
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), " ").concat(sizes[i]);
    },
    getTableReference: function getTableReference(item) {
      var tableReference = {
        datasetId: item.dataset,
        projectId: item.proyecto,
        tableId: item.titulo
      };
      return tableReference;
    },
    onVerTable: function onVerTable(item) {
      var _this6 = this;
      this.source = item.source;
      if (item.source == 'synapse') {
        this.isSynapse = true;
      } else {
        this.isSynapse = false;
      }
      var relativeResourceName = item.id_inca;
      ////console.log("idinca",item)
      var modalName = this.MODAL_NAME_METADATA_VIEW;
      var rowData = {
        relativeResourceName: relativeResourceName,
        objectId: item.proyecto + ":" + item.dataset + "." + item.titulo,
        //'piloto-druid-spsa:caldana.tmp_clientes_total',
        tableReference: this.getTableReference(item),
        domain_table: item.dominio,
        domain: item.dominio,
        index_node: '',
        source: this.source ? this.source : "bigquery"
      };
      var params = {
        relativeResourceName: relativeResourceName,
        pageSize: 10,
        email: window.userInfo.email,
        //index_node: rowData.index_node,
        domain_table: item.dominio,
        source: this.source ? this.source : "bigquery"
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response && response.code === 200) {
          _this6.objToRequest = response.data;
          _this6.objToRequest.item = rowData;
          _this6.objToRequest.tipo = 'edicion';
          _this6.key_view += 1;
          _this6.$refs[modalName].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onRequestTable: function onRequestTable(item) {
      var _this7 = this;
      this.source = item.source;
      if (item.source == 'synapse') {
        this.isSynapse = true;
      } else {
        this.isSynapse = false;
      }
      var relativeResourceName = item.id_inca;
      var modalName = this.MODAL_NAME;
      var rowData = {
        relativeResourceName: relativeResourceName,
        objectId: item.proyecto + ":" + item.dataset + "." + item.titulo,
        //'piloto-druid-spsa:caldana.tmp_clientes_total',
        tableReference: this.getTableReference(item),
        domain_table: item.dominio,
        domain: item.dominio,
        index_node: '',
        source: this.source ? this.source : "bigquery"
      };

      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: relativeResourceName,
        pageSize: 10,
        email: window.userInfo.email,
        //index_node: rowData.index_node,
        domain_table: item.dominio,
        source: this.source ? this.source : "bigquery"
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this7.objToRequest = response.data;
          _this7.objToRequest.item = rowData;
          _this7.objToRequest.tipo = 'edicion';
          //this.$bvModal.show(modalName)
          _this7.key_request += 1;
          _this7.$refs[modalName].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onChangeTable: function onChangeTable(item) {
      var _this8 = this;
      this.source = item.source;
      if (item.source == 'synapse') {
        this.isSynapse = true;
      } else {
        this.isSynapse = false;
      }
      ////console.log(item)
      var relativeResourceName = item.id_inca;
      var modalName = this.MODAL_NAME_METADATA;
      var rowData = {
        relativeResourceName: relativeResourceName,
        objectId: item.proyecto + ":" + item.dataset + "." + item.titulo,
        //'piloto-druid-spsa:caldana.tmp_clientes_total',
        tableReference: this.getTableReference(item),
        domain_table: item.dominio,
        domain: item.dominio,
        index_node: '',
        source: item.source ? item.source : "bigquery"
      };

      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: relativeResourceName,
        pageSize: 10,
        email: window.userInfo.email,
        //index_node: rowData.index_node,
        domain_table: item.dominio,
        source: this.source ? this.source : "bigquery"
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this8.objToRequest = response.data;
          _this8.objToRequest.item = rowData;
          _this8.objToRequest.tipo = 'edicion';
          //this.$bvModal.show(modalName)
          _this8.key_meta += 1;
          _this8.$refs[modalName].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onVerTerm: function onVerTerm(item) {
      var _this9 = this;
      userSecurityService.getDomainUser({
        email: item.data_operator
      }).then(function (response) {
        var emailDomain = response.data.domain;
        _this9.$router.push({
          path: "/BusinessTerm/".concat(emailDomain, "/").concat(item.id_inca)
        });
      });
      //const emailDomain = utils.getDomainFromEmail(item.data_operator)
    },
    onVerObjeto: function onVerObjeto(item) {
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.VIEW_METADATA,
          object: item.tipo_objeto,
          domain_object: item.dominio,
          operator: this.stringToHash(item.data_operator),
          object_name: item.titulo,
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          module: 'data_platform'
        });
      }
      switch (item.tipo_objeto) {
        case TYPSE_SENSE_TYPE_OBJECTS.TABLE:
          this.onVerTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.VIEW:
          this.onVerTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TERM:
          this.onVerTerm(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE:
          this.openMetaDatasource(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_DATASOURCE_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD:
          this.openMetaWorkbook(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_WORKBOOK_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET:
          this.openMetaDataset(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_DATASET_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT:
          this.openMetaReport(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_REPORT_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT:
          this.openMetaReportGds(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_REPORT_METADATA_VIEW_GDS);
          break;
        default:
          break;
      }
    },
    onRequestObjeto: function onRequestObjeto(item) {
      switch (item.tipo_objeto) {
        case TYPSE_SENSE_TYPE_OBJECTS.TABLE:
          this.onRequestTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.VIEW:
          this.onRequestTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE:
          this.tableauType = 'datasource';
          this.openModalSelectTableauUser(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD:
          this.tableauType = 'workbook';
          this.openModalSelectTableauUser(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET:
          this.biType = 'dataset';
          this.openModalSelectBIUser(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT:
          this.biType = 'report';
          this.openModalSelectBIUser(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT:
          this.biType = 'report';
          this.openModalSelectBIUser(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT:
          this.openMetaReportGds(item, this.ACCESS_TYPE_FLOW.ACCESS, this.MODAL_REPORT_METADATA_ACCESS_GDS);
          break;
        default:
          break;
      }
    },
    onChangeObjeto: function onChangeObjeto(item) {
      switch (item.tipo_objeto) {
        case TYPSE_SENSE_TYPE_OBJECTS.TABLE:
          this.onChangeTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.VIEW:
          this.onChangeTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE:
          this.openMetaDatasource(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_DATASOURCE_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD:
          this.openMetaWorkbook(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_WORKBOOK_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET:
          this.openMetaDataset(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_DATASET_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT:
          this.openMetaReport(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_REPORT_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT:
          this.openMetaReportGds(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_REPORT_METADATA_VIEW_GDS);
          break;
        default:
          break;
      }
    },
    openMetaDatasource: function openMetaDatasource(item, isChangeRequest, modalDatasourceMetadataView, userTableau) {
      var _this0 = this;
      var requestData = {
        domain: item.dominio,
        page: 1,
        limit: 10,
        allDomains: false,
        searchDomain: item.dominio,
        clauses: {
          document_id: item.id_inca
        },
        filters: []
      };
      TableauDatasourceService.tableauDataSourceQueryAllDomain(requestData).then(function (res) {
        if (res.code === 200 && res.success) {
          var obj = res.data.result;
          obj.domain = item.dominio;
          _this0.userTableau = userTableau;
          _this0.isChangeRequest = isChangeRequest;
          _this0.objDatasource = obj;
          _this0.$refs[modalDatasourceMetadataView].onOpen();
        }
      });
    },
    openMetaWorkbook: function openMetaWorkbook(item, isChangeRequest, modalWorkbookMetadataView, userTableau) {
      var _this1 = this;
      var requestData = {
        domain: item.dominio,
        page: 1,
        limit: 10,
        allDomains: false,
        searchDomain: item.dominio,
        clauses: {
          document_id: item.id_inca
        },
        filters: []
      };
      TableauDashboardService.tableauWorkBookQueryAllDomain(requestData).then(function (res) {
        if (res.code === 200 && res.success) {
          var obj = res.data.result;
          obj.domain = item.dominio;
          _this1.userTableau = userTableau;
          _this1.isChangeRequest = isChangeRequest;
          _this1.objDashboard = obj;
          _this1.$refs[modalWorkbookMetadataView].onOpen();
        }
      });
    },
    openModalSelectTableauUser: function openModalSelectTableauUser(item) {
      var _this10 = this;
      var requestData = {
        domain: item.dominio,
        page: 1,
        limit: 10,
        allDomains: false,
        searchDomain: item.dominio,
        clauses: {
          document_id: item.id_inca
        },
        filters: []
      };
      if (this.tableauType == "datasource") {
        TableauDatasourceService.tableauDataSourceQueryAllDomain(requestData).then(function (res) {
          if (res.code === 200 && res.success) {
            var obj = res.data.result;
            obj.domain = item.dominio;
            _this10.objDatasource = obj;
            _this10.userTableau = null;
            TableauUserAccessService.getUserTableauByEmail().then(function (response) {
              _this10.userTableauOptions = [{
                value: null,
                text: 'Please select an user'
              }].concat(response.data);
              _this10.$refs[_this10.MODAL_SELECT_USER_TABLEAU].onOpen();
            });
          }
        });
      } else {
        TableauDashboardService.tableauWorkBookQueryAllDomain(requestData).then(function (res) {
          if (res.code === 200 && res.success) {
            var obj = res.data.result;
            obj.domain = item.dominio;
            _this10.objDashboard = obj;
            _this10.userTableau = null;
            TableauUserAccessService.getUserTableauByEmail().then(function (response) {
              _this10.userTableauOptions = [{
                value: null,
                text: 'Please select an user'
              }].concat(response.data);
              _this10.$refs[_this10.MODAL_SELECT_USER_TABLEAU].onOpen();
            });
          }
        });
      }
    },
    openMetaDataset: function openMetaDataset(item, isChangeRequest, modalDatasetMetadataView, userBI, emailBI) {
      var _this11 = this;
      var params = {
        dataset_id: item.id_inca
      };
      BiDatasetService.getDatasetById(params).then(function (res) {
        _this11.userBI = userBI;
        _this11.emailBI = emailBI;
        _this11.isChangeRequest = isChangeRequest;
        _this11.objDataset = res.data;
        _this11.objDataset.domain = item.dominio;
        _this11.$refs[modalDatasetMetadataView].onOpen();
      });
    },
    openMetaReport: function openMetaReport(item, isChangeRequest, modalReportMetadataView, userBI, emailBI) {
      var _this12 = this;
      var params = {
        report_id: item.id_inca
      };
      BiReportService.getReportById(params).then(function (res) {
        _this12.userBI = userBI;
        _this12.emailBI = emailBI;
        _this12.isChangeRequest = isChangeRequest;
        _this12.objReport = res.data;
        _this12.objReport.domain = item.dominio;
        _this12.$refs[modalReportMetadataView].onOpen();
      });
    },
    openModalSelectBIUser: function openModalSelectBIUser(item) {
      var _this13 = this;
      if (this.biType == 'dataset') {
        var params = {
          dataset_id: item.id_inca
        };
        BiDatasetService.getDatasetById(params).then(function (res) {
          _this13.objDataset = res.data;
          _this13.objDataset.domain = item.dominio;
          _this13.userBI = null;
          BiUserAccessService.getUserbiByEmail().then(function (response) {
            response.data.push({
              text: window.userInfo.email,
              value: window.userInfo.email
            });
            _this13.userBIOptions = [{
              value: null,
              text: 'Please select an user'
            }].concat(response.data);
            _this13.$refs[_this13.MODAL_SELECT_USER_BI].onOpen();
          });
        });
      } else {
        var _params = {
          report_id: item.id_inca
        };
        BiReportService.getReportById(_params).then(function (res) {
          _this13.objReport = res.data;
          _this13.objReport.domain = item.dominio;
          _this13.userBI = null;
          BiUserAccessService.getUserbiByEmail().then(function (response) {
            response.data.push({
              text: window.userInfo.email,
              value: window.userInfo.email
            });
            _this13.userBIOptions = [{
              value: null,
              text: 'Please select an user'
            }].concat(response.data);
            _this13.$refs[_this13.MODAL_SELECT_USER_BI].onOpen();
          });
        });
      }
    },
    openMetaReportGds: function openMetaReportGds(item, type, modalName) {
      var _this14 = this;
      var params = {
        report_id: item.id_inca
      };
      DatastudioReportService.getReportById(params).then(function (res) {
        _this14.userBI = window.userInfo.email;
        _this14.isChangeRequest = type;
        _this14.objReportGds = res.data;
        _this14.$refs[modalName].onOpen();
      });
    },
    getResources: function getResources() {
      var _this15 = this;
      resources_service.getResources().then(function (response) {
        ////console.log(response)
        if (response.data) {
          _this15.$store.commit('data-platform/set_projects', response.data.projects);
          _this15.$store.commit('data-platform/set_catalogs', response.data.catalogs);
        }
      });
    },
    onHelpCenter: function onHelpCenter() {
      this.$router.push({
        name: 'help_main'
      });
    },
    onDrawerMini: function onDrawerMini() {
      if (!this.mini) {
        this.mini = true;
      } else {
        this.drawer = !this.drawer;
      }
      ////console.log("mini: ", this.mini)
      ////console.log("drawer: ", this.drawer)
    },
    onClickButton: function onClickButton(button) {
      this.pill_selected = button;
      this.buttons.forEach(function (item) {
        item.state = item.name === button.name;
      });
      var isSearch = this.sendToSearch();
      if (!isSearch) {
        return;
      }
      this.$bus.$emit('click-pill-search', button);
      if (!isSearch) {
        return;
      }
      this.$store.dispatch('data-platform/setMainQueryBy', button.name);
    },
    onKeyup: function onKeyup(e) {
      this.$refs.search.focus();
    },
    changeButtonState: function changeButtonState() {
      var _this16 = this;
      this.$store.dispatch('data-platform/getIsTableauActive').then(function () {
        _this16.buttons = [{
          caption: 'Table/View',
          key: 'menu.toolbar.table_views',
          state: _this16.$route.query.table === 'true' || false,
          color: 'success',
          name: 'table',
          disabled: false
        }, {
          caption: 'Business Term',
          key: 'menu.toolbar.business_terms',
          state: _this16.$route.query.business === 'true' || false,
          color: 'indigo',
          name: 'business',
          disabled: false
        }, {
          caption: 'TBL DataSource',
          key: 'menu.toolbar.tbl_datasources',
          state: _this16.$route.query.datasource === 'true' || false,
          color: 'orange',
          name: 'datasource',
          disabled: !_this16.isTableauActive
        }, {
          caption: 'TBL Dashboard',
          key: 'menu.toolbar.tbl_dashboards',
          state: _this16.$route.query.dashboard === 'true' || false,
          color: 'brown',
          name: 'dashboard',
          disabled: !_this16.isTableauActive
        }, {
          caption: 'PBI Dataset',
          key: 'menu.toolbar.pbi_datasets',
          state: _this16.$route.query.dataset === 'true' || false,
          color: 'bids',
          name: 'dataset',
          disabled: !_this16.isPowerBIActive
        }, {
          caption: 'PBI Report',
          key: 'menu.toolbar.pbi_reports',
          state: _this16.$route.query.report === 'true' || false,
          color: 'birp',
          name: 'report',
          disabled: !_this16.isPowerBIActive
        }, {
          caption: 'GDS Report',
          key: 'menu.toolbar.gds_reports',
          state: _this16.$route.query.report_gds === 'true' || false,
          color: 'gdsr',
          name: 'report_gds',
          disabled: !_this16.isDataStudioActive
        }, {
          caption: 'All',
          key: 'menu.toolbar.all',
          state: _this16.$route.query.all === 'true' || false,
          color: 'primary',
          name: 'all',
          disabled: false
        }];
        if (_this16.buttons.filter(function (x) {
          return x.state == true;
        }).length == 0) {
          _this16.buttons[0].state = true;
          _this16.pill_selected = _this16.buttons[0];
        }
        _this16.$store.dispatch('data-platform/setMainQueryBy', _this16.buttons.filter(function (x) {
          return x.state == true;
        })[0].name);
        ////console.log(this.mainQueryBy)
      });
    },
    debounceInput: debounce(function (e) {
      var _this17 = this;
      userSettingsService.get_last_searchs({
        "email": this.userInfo.email
      }).then(function (response) {
        if (response.data) _this17.searchs = response.data;
        //console.log("searchs: ", this.searchs)
      });
      //console.log("asdadasdasd")
      //this.$store.dispatch('updateInput', e.target.value)
      //console.log("aqui", this.isPageSearch)
      if (this.isPageSearch) this.sugerir();
    }, 500),
    sugerir: function sugerir() {
      //console.log("entrando")
      if (this.q && this.q.length >= 3) {
        this.getTypesense();
      } else {
        this.mostrarSugerencia = false;
      }
    },
    sendToSearch: function sendToSearch() {
      console.log("send to search: " + this.q);
      if (!this.q) {
        return false;
      }
      this.menuBuscador = false;
      if (this.q.trim().length == 0 || this.q.trim().length < 3) {
        tasks.toast.error('Enter at least 3 characters!');
        // this.$toast.warning('Enter at least 3 characters!')
        return false;
      }
      var objetos2 = "";
      console.log("dbug", this.filtrosbusqueda);
      for (var _i = 0, _Object$entries = Object.entries(this.filtrosbusqueda.object); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        objetos2 += ',' + value.value;
      }
      var object3 = "";
      for (var _i2 = 0, _Object$entries2 = Object.entries(this.filtrosbusqueda.query_by); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          _key = _Object$entries2$_i[0],
          _value = _Object$entries2$_i[1];
        object3 += ',' + _value.value;
      }
      this.mostrarSugerencia = false;
      // change url
      var c = {};
      this.q = this.preparedSearch(this.q);
      var key_t_v = TYPSE_SENSE_TYPE_OBJECTS.TABLE + ',' + TYPSE_SENSE_TYPE_OBJECTS.VIEW;
      c = {
        all: false,
        table: objetos2.indexOf(key_t_v) != -1,
        term: objetos2.indexOf(TYPSE_SENSE_TYPE_OBJECTS.TERM) != -1,
        data: objetos2.indexOf(TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE) != -1,
        book: objetos2.indexOf(TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD) != -1,
        dataset: objetos2.indexOf(TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET) != -1,
        report: objetos2.indexOf(TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT) != -1,
        report_gds: objetos2.indexOf(TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT) != -1,
        titulo: object3.indexOf('titulo') != -1,
        description: object3.indexOf('description') != -1
      };
      //console.log(objetos2, c, key_t_v, [objetos].includes(objetos2.indexOf(key_t_v) != -1))
      var objetos = [];
      for (var _i3 = 0, _Object$entries3 = Object.entries(this.filtrosbusqueda.object); _i3 < _Object$entries3.length; _i3++) {
        var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
          _key2 = _Object$entries3$_i[0],
          _value2 = _Object$entries3$_i[1];
        objetos.push(_value2.value);
      }
      if (objetos.length > 0) {
        for (var _i4 = 0, _Object$entries4 = Object.entries(c); _i4 < _Object$entries4.length; _i4++) {
          var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
            _key3 = _Object$entries4$_i[0],
            _value3 = _Object$entries4$_i[1];
          if (objetos.includes(_key3)) {
            c[_key3] = true;
          }
        }
      } else {
        c['all'] = true;
      }
      if (!this.filtro.domain) {
        this.filtro.domain = 'all';
      }
      //this.$bus.$emit('click-pill-search', this.buttons.filter(x => x.state === true)[0])
      this.$store.dispatch('data-platform/guardarfiltrosbusqueda', _objectSpread(_objectSpread({}, this.filtrosbusqueda), {}, {
        semanticSearch: this.semanticSearch
      }));
      this.$router.push({
        name: 'ContObjectSearch',
        params: {
          q: this.q,
          domain: this.filtrosbusqueda.domain
        },
        query: c
      });
      return true;
    },
    preparedSearch: function preparedSearch(search) {
      var busqueda = search.toLowerCase();
      var aux = [];
      for (var x = 0; x < busqueda.length; x++) {
        aux.push(busqueda.charAt(x));
      }
      if (aux[0] === ' ') {
        aux.splice(0, 1);
      }
      if (aux[aux.length - 1] === ' ') {
        aux.pop();
      }
      busqueda = aux.join('');
      return busqueda;
    },
    getTypesense: function getTypesense() {
      var _this18 = this;
      this.peticionesBuscador += 1;
      this.mostrarSugerencia = true;
      this.filtro.q = this.q;
      if (this.filtro.domain == null) {
        this.filtro.domain = '';
      } else if (this.filtro.domain.toUpperCase() === 'ALL') {
        this.filtro.domain = '';
      }
      if (this.filtro.object == null) {
        this.filtro.object = '';
      }
      var objetos = [];
      for (var _i5 = 0, _Object$entries5 = Object.entries(this.filtro.object); _i5 < _Object$entries5.length; _i5++) {
        var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i5], 2),
          key = _Object$entries5$_i[0],
          value = _Object$entries5$_i[1];
        objetos.push(value.value);
      }
      this.filtro.object_comma = objetos.join(',');
      // =========================
      if (this.filtro.query_by == null) {
        this.filtro.query_by = '';
      }
      var query_by = [];
      for (var _i6 = 0, _Object$entries6 = Object.entries(this.filtro.query_by); _i6 < _Object$entries6.length; _i6++) {
        var _Object$entries6$_i = _slicedToArray(_Object$entries6[_i6], 2),
          _key4 = _Object$entries6$_i[0],
          _value4 = _Object$entries6$_i[1];
        query_by.push(_value4.value);
      }
      this.filtro.query_by_comma = query_by.join(',');
      var params = Object.assign({}, this.filtro);
      if (params.domain.toUpperCase() === '') {
        var domains = "";
        this.processd_list_domains.forEach(function (x) {
          if (domains != '') domains += ',';
          domains += x.value;
        });
        params.domain = domains;
      }
      ////console.log(params)
      this.estaBuscando = true;
      var searchCall = this.semanticSearch ? search_engine_service.getVectorSearch(params) : search_engine_service.getBuscador(params);
      searchCall.then(function (response) {
        _this18.encontrado = response;
        _this18.existeBusqueda = _this18.encontrado.found > 0;
        _this18.estaBuscando = false;
        _this18.peticionesBuscador -= 1;
      }, function (err) {
        _this18.estaBuscando = false;
        _this18.peticionesBuscador -= 1;
      }).then(function () {
        if (!_this18.semanticSearch) _this18.buscarDatosAdicionales();
      });
      ////console.log(this.mostrarSugerencia)
    },
    buscarDatosAdicionales: function buscarDatosAdicionales() {
      var _this19 = this;
      if (this.peticionesBuscador > 0) return;
      var tables_send = [];
      if (!this.encontrado.busqueda) return;
      var test = this.encontrado.busqueda;
      var tables = test.filter(function (table) {
        return table.tipo_objeto == "table";
      });
      if (tables.length > 0) {
        tables.forEach(function (item) {
          tables_send.push({
            projectId: item.proyecto,
            datasetId: item.dataset,
            tableId: item.titulo,
            domain_table: item.dominio,
            source: item.source ? item.source : "bigquery"
          });
        });
        var params = {
          'tables': tables_send
        };
        assignments_service.getTablesDetails(params).then(function (response) {
          var tables_metadata = response.data;
          tables = tables.map(function (item) {
            var temp = Object.assign({}, item);
            var table = temp;
            var id = table.proyecto + ":" + table.dataset + "." + table.titulo;
            var bytes = tables_metadata[id].numBytes || '0';
            var numRows = tables_metadata[id].numRows || '0';
            temp.numBytes = bytes;
            temp.numRows = numRows;
            return temp;
          });
          _this19.encontrado.busqueda = _this19.encontrado.busqueda.map(function (obj) {
            return tables.find(function (o) {
              return o.titulo === obj.titulo;
            }) || obj;
          });
        });
      }
    },
    fueraDeDiv: function fueraDeDiv() {
      this.q = '';
      this.mostrarSugerencia = false;
    },
    switchColor: function switchColor(value) {},
    subscribeMessaging: function () {
      var _subscribeMessaging = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this20 = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              //console.log('Load token FCM')
              if (firebase.messaging.isSupported()) {
                firebase.messaging().getToken({
                  vapidKey: this.pushWeb
                }).then(/*#__PURE__*/function () {
                  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(token) {
                    var currentToken;
                    return _regenerator().w(function (_context2) {
                      while (1) switch (_context2.n) {
                        case 0:
                          if (!token) {
                            _context2.n = 2;
                            break;
                          }
                          currentToken = _this20.messagingToken; //console.log(currentToken)
                          //console.log(token)
                          if (!(!currentToken || currentToken && currentToken !== token)) {
                            _context2.n = 1;
                            break;
                          }
                          _context2.n = 1;
                          return userSecurotyService.updateMessagingToken({
                            messagingToken: token
                          });
                        case 1:
                          _context2.n = 3;
                          break;
                        case 2:
                          //console.log('No registration token available. Request permission to generate one.')
                          _this20.requestPermission();
                        case 3:
                          return _context2.a(2);
                      }
                    }, _callee2);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  //console.log('An error occurred while retrieving token. ', err)
                  _this20.requestPermission();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function subscribeMessaging() {
        return _subscribeMessaging.apply(this, arguments);
      }
      return subscribeMessaging;
    }(),
    requestPermission: function requestPermission() {
      var _this21 = this;
      Notification.requestPermission().then(function (permission) {
        if (permission === 'granted') {
          //console.log('Notification permission granted!')
          _this21.subscribeMessaging();
        } else {
          //console.log('Unable to get permission to norify')
        }
      });
    },
    startListeners: function () {
      var _startListeners = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.startTokenRefreshListener();
            case 1:
              _context4.n = 2;
              return this.requestPermission();
            case 2:
              this.subscribeMessaging();
              _context4.n = 3;
              return this.getIdToken();
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function startListeners() {
        return _startListeners.apply(this, arguments);
      }
      return startListeners;
    }(),
    startTokenRefreshListener: function startTokenRefreshListener() {
      var _this22 = this;
      try {
        if (firebase.messaging.isSupported()) {
          firebase.messaging().onTokenRefresh(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
            var token, _t;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.p = _context5.n) {
                case 0:
                  _context5.p = 0;
                  _context5.n = 1;
                  return firebase.messaging().getToken({
                    vapidKey: _this22.pushWeb
                  });
                case 1:
                  token = _context5.v;
                  _context5.n = 2;
                  return userSecurotyService.updateMessagingToken({
                    messagingToken: token
                  });
                case 2:
                  _context5.n = 4;
                  break;
                case 3:
                  _context5.p = 3;
                  _t = _context5.v;
                  console.error('Error : ', _t);
                case 4:
                  return _context5.a(2);
              }
            }, _callee5, null, [[0, 3]]);
          })));
        }
      } catch (e) {
        console.error('Error : ', e);
      }
    }
  }, "requestPermission", function () {
    var _requestPermission = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var permission, _t2;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _context6.p = 0;
            _context6.n = 1;
            return Notification.requestPermission();
          case 1:
            permission = _context6.v;
            _context6.n = 3;
            break;
          case 2:
            _context6.p = 2;
            _t2 = _context6.v;
            console.error('Error : ', _t2);
          case 3:
            return _context6.a(2);
        }
      }, _callee6, null, [[0, 2]]);
    }));
    function requestPermission() {
      return _requestPermission.apply(this, arguments);
    }
    return requestPermission;
  }()), "getIdToken", function () {
    var _getIdToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var idToken, _t3;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            _context7.p = 0;
            if (!firebase.messaging.isSupported()) {
              _context7.n = 2;
              break;
            }
            _context7.n = 1;
            return firebase.messaging().getToken({
              vapidKey: this.pushWeb
            });
          case 1:
            idToken = _context7.v;
            _context7.n = 2;
            return userSecurotyService.updateMessagingToken({
              messagingToken: idToken
            });
          case 2:
            _context7.n = 4;
            break;
          case 3:
            _context7.p = 3;
            _t3 = _context7.v;
            console.error('Error : ', _t3);
          case 4:
            return _context7.a(2);
        }
      }, _callee7, this, [[0, 3]]);
    }));
    function getIdToken() {
      return _getIdToken.apply(this, arguments);
    }
    return getIdToken;
  }()), "checkPageDataPlatform", function checkPageDataPlatform() {
    ////console.log('**********************')
    ////console.log("pagina:",this.$router.history.current.path)
    this.isPageDataPlatform = this.$router.history.current.path.indexOf('attributes') == -1;
    ////console.log("isplatform:",this.isPageDataPlatform)
  }), "checkPageSearch", function checkPageSearch() {
    ////console.log('**********************')
    ////console.log("pagina:",this.$router.history.current.path)
    this.isPageSearch = this.$router.history.current.path.indexOf('ContObjectSearch') == -1;
    ////console.log("issearch:",this.isPageSearch)
  }), "checkPageHome", function checkPageHome() {
    ////console.log('**********************')
    ////console.log("paginahome:",this.$router.history.current.path)
    this.isPageHome = this.$router.history.current.path.indexOf('Home') == 1;
    ////console.log("ishome:",this.isPageHome)
  }), "check_access_function", function check_access_function(source, domain) {
    var key = 'has_' + source + '_access_function';
    var status = this.orgs.find(function (objeto) {
      return objeto.domain === domain;
    })[key];
    return status;
  }))
};